import config from '@/common/config'
import { fail, success } from '@/helpers/result-helper'
import { isSuccess } from '@/helpers/http-status-helpers'
import toasts from '@/services/toasts/index'
import { getType } from 'mime'

const getDefaultState = () => {
  return {
    // Place any new state properties here
    loadingCount: 0,
    crudLoadingCount: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'file',
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async download({ commit }, fileId) {
      commit('START_LOADING')
      try {
        const response = await this.$api.file.createFileAccessToken(fileId)
        if (isSuccess(response.status)) {
          const token = response.data.accessKey
          const baseURL = `${config.get('apiUrl')}v${config.get('apiVersion')}`
          const fileURL = `${baseURL}/file/(${token})`
          try {
            const fileResponse = await this.$api.file.get(`(${token})`)
            if (isSuccess(fileResponse.status)) {
              window.location = fileURL
            }
          } catch (ex) {
            throw Error('Download Failed')
          }
          return success()
        } else {
          toasts.error('Download Failed')
        }
      } catch {
        toasts.error('Download Failed')
        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },
    async downloadGeneralFile({ commit }, filePath) {
      commit('START_LOADING')

      try {
        const response = await this.$api.file.getGeneralFile(filePath)

        if (isSuccess(response.status)) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: getType(filePath) })
          )
          return success(url)
        }
      } catch (ex) {
        let toastErrorMessage = this.$i18n.t('error.errorGenericApiErrorText')
        // Try to resolve error response. Response type is Blob, need to convert
        // from blob to json
        try {
          const responseObject = JSON.parse(await ex.response.data.text())
          if (responseObject) toastErrorMessage = responseObject.message
        } catch {}

        toasts.error(toastErrorMessage)

        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },
  },
}
